module.exports = __webpack_public_path__ + "static/media/grin-tongue.96e8d19b.svg";